import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useMediaQuery } from "@mui/material";
import { requestDeletingOrganization } from "../../redux/actions/organizationProfileCreators";
import {
  requestCancelInvitation,
  requestDeleteincompleteOrga,
  requestDissociationUser,
} from "../../redux/actions/usersManagementActionCreators";

export default function ControlDelete({
  open,
  handleClose,
  profile,
  user,
  page,
  searchText,
  status,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleDelete = () => {
    if (user?.role === "enterprise_user" && !user?.status) {
      dispatch(
        requestDeletingOrganization(page, searchText, status, profile?.id)
      );
      dispatch(
        requestCancelInvitation(
          user?.id,
          user?.first_name,
          user?.last_name,
          user?.email,
          4,
          "",
          "all",
          null
        )
      );
    } else if (
      user?.role === "enterprise_user" &&
      user?.status &&
      profile?.tabs_completed === 6
    ) {
      dispatch(
        requestDissociationUser({
          id: user?.id,
          first_name: user?.first_name,
          last_name: user?.last_name,
          email: user?.email,
          page: page,
          searchText: searchText,
          status: status,
        })
      );
    } else if (
      user?.role === "enterprise_user" &&
      user?.status &&
      profile?.tabs_completed !== 6
    ) {
      dispatch(
        requestDeleteincompleteOrga(
          user?.id,
          user?.first_name,
          user?.last_name,
          user?.email,
          page,
          searchText,
          status
        )
      );
    }
    handleClose();
  };

  const isMobile = useMediaQuery("(max-width:1400px)");
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "30%", padding: "20px " }
            : { width: "90%", height: "80%", margin: "5px 0", padding: "5px " },
        }}
        disableBackdropClick
        disableEnforceFocus
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>

        <DialogTitle mb={1} align="center">
          <Typography variant="title" sx={{ fontSize: "38px" }}>
            {t("delete_organization")}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: "15px 10px" }}>
          <DialogContentText mb={2} align="center">
            {user?.status
              ? `${t("delete_orga1")}${user?.first_name} ${
                  user?.last_name
                }. ${t("delete_orga1_1")}`
              : `${t("delete_orga2")}${user?.first_name} ${
                  user?.last_name
                }. ${t("delete_orga2_2")}`}
          </DialogContentText>
          <DialogContentText mb={1} align="center" id="delete-orga">
            <span style={{ fontWeight: 700 }}>{t("are_you_sure_delete")}</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid container>
            <Grid item xs={12} mb={2}>
              <Button
                variant="contained"
                color="error"
                fullWidth
                sx={{ height: "50px", borderRadius: "10px" }}
                onClick={handleDelete}
              >
                {t("delete_organization")}
              </Button>
            </Grid>
          </Grid>
          {/* )} */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
